<template>
    <div class="instruction" style="background-color:#F0F3F6;">
        <el-row  style="padding:10px 35px 0px 35px;margin-bottom: 2px;box-sizing: border-box;">
            <i style="color: #666;" class="el-icon-caret-left" @click="goBack"></i>
            <span style="font-size: 14px;color: #666;" @click="goBack">返回</span>
            <span style="margin: 0px 15px;">|</span>
            <span style="font-size: 14px;color:#333">开放平台/接入文档</span>
        </el-row>
        <el-container style="width:100%;padding:12px 18px;box-sizing: border-box;">
            <el-aside id="aside" style="width: 45%;box-shadow: 0px 5px 5px #bbb;">
                <el-container class="white">
                    <el-header style="height:47px;display:flex;align-item:center;line-height:47px;border-bottom:1px solid #ECECEC;"><span class="blueido"></span><span>重要说明</span></el-header>
                    <el-main>
                        <p style="padding-left:5px;padding-right:25px;margin:0px;color: #606266;">
                            1.接口调用者在调用API时，需按照下方请求参数和签名算法，生成签名，并附带到API请求
                        </p>
                        <p style="padding-left:5px;padding-right:25px;color: #606266;">
                            2.仅支持后台服务程序、客户端程序、APP调用，切勿直接使用JavaScript、小程序前端等直接暴露accessKey、secretKey和签名算法的方式调用。如有需求，可让后台服务实现签名，再由前端程序调用
                        </p>
                    </el-main>
                </el-container>
                <el-container class="white">
                    <el-header style="height:47px;display:flex;align-item:center;line-height:47px;border-bottom:1px solid #ECECEC;"><span class="blueido"></span><span>请求参数</span></el-header>
                    <el-main>
                        <el-table
                            :data="paramData"
                        >
                            <el-table-column  align="center"  label="参数名">
                                <template slot-scope="scope">
                                {{ scope.row.name}}
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" label="参数值样例">
                                <template slot-scope="scope">
                                {{ scope.row.params}}
                                </template>
                            </el-table-column>
                            <el-table-column  align="center"  label="备注">
                                <template slot-scope="scope">
                                {{ scope.row.memo}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-main>
                </el-container>
                <el-container class="white" style="margin-bottom: 0px;box-shadow: 5px 5px 5px #bbb;">
                    <el-header style="height:47px;display:flex;align-item:center;line-height:47px;border-bottom:1px solid #ECECEC;"><span class="blueido"></span><span>请求流程</span></el-header>
                    <el-main class="elcontent">
                        <p style="margin:0px;"><span class="dian"></span>1.accessKey 和 secretKey 可通过智能互联云平台/开放平台获取</p>
                        <p><span class="dian"></span>2.accessKey+nonce+timestamp 拼接得到stringA</p>
                        <p><span class="dian"></span>3.对stringA进行HMAC-SHA1，密钥为secretKey，得到stringB</p>
                        <p><span class="dian"></span>4.对stringB进行大写转换，得到sign</p>
                        <p><span class="dian"></span>5.sign自生成起，有效期为5分钟，且只可使用一次</p>
                        <p><span class="dian"></span>6.请求参数按顺序传递，如 api_address?ak=xxx&&nonce=xxx&sign=xxx&timestamp=xxx</p>
                    </el-main>
                </el-container>
            </el-aside>
            <el-main style="width: 53%;padding-top:0px ;padding-bottom: 0px;padding-right: 0px;box-shadow: 5px 5px 5px #bbb;">
                <el-container class="white" style="height: 100%;margin-bottom: 0px;">
                    <el-form style="width: 100%;" :style="{'height':rightContentHeight}">
                    <el-header style="height:47px;display:flex;align-item:center;line-height:47px;border-bottom:1px solid #ECECEC;">
                        <span class="blueido"></span>
                        <span :class="goif==1?'activeheader':''" @click="ifgo(1)" style="margin-right: 5px;padding-left: 15px;padding-right: 15px;">参考代码(GO)</span>
                        <span :class="goif==2?'activeheader':''" @click="ifgo(2)" style="padding-left: 15px;padding-right: 15px;">参考代码(JAVA)</span>
                    </el-header>
                    <el-main  v-show="goif==1" style="padding:27px 40px 10px 40px;box-sizing: border-box;background-color: #fff;">
                        <div class="daima">
                        <p>func NewSign(accessKey, nonce, timestamp, secretKey string) string{</p>
                        <p style="padding-left:15px;">//拼接stringA</p>
                        <p style="padding-left:15px;margin-bottom:30px;">stringA  := accessKey + nonce + timestamp</p>
                        <p style="padding-left:15px">//HmacSHA1 秘钥secretKey</p>
                        <p style="padding-left:15px;margin-bottom:30px;">h := hmac.New(sha1.New, []byte(secretKey))</p>
                        <p style="padding-left:15px">//写入stringA</p>
                        <p style="padding-left:15px;margin-bottom:30px;"> h.Write([]byte(stringA))</p>
                        <p style="padding-left:15px">//转换为大写</p>
                        <p style="padding-left:15px">sign := strings.ToUpper(hex.EncodeToString(h.Sum(nil)))</p>
                        <p style="padding-left:15px">return sign</p>
                        <p>}</p>
                        </div>
                    </el-main>

                    <!-- <el-header style="height:47px;display:flex;align-item:center;line-height:47px;border-bottom:1px solid #ECECEC;"><span class="blueido"></span><span>参考代码(JAVA)</span></el-header> -->
                    <el-main v-show="goif==2" style="padding:7px 40px 90px 40px;box-sizing: border-box;background-color: #fff;">
                        <div class="daima">
                        <p>/**</p>
                        <p style="padding-left:6px;">* 获取签名</p>
                        <p style="padding-left:6px;">*</p>
                        <p style="padding-left:6px;">* @param accessKey 公钥</p>
                        <p style="padding-left:6px;">* @param nonce     10位随机字符</p>
                        <p style="padding-left:6px;">* @param timestamp unix时间蹉</p>
                        <p style="padding-left:6px;">* @param secreKey  私钥</p>
                        <p style="padding-left:6px;">* @return 签名值</p>
                        <p style="padding-left:6px;">*/</p>
                        <p>public static String getSign(String accessKey, String nonce, String </p>
                            <p style="padding-left: 0px;">  timestamp , String secreKey) {</p>
                            <p style="padding-left:30px;">String s = accessKey + nonce + timestamp;</p>
                            <p style="padding-left:30px;">String hmacSHA1Encrypt = hmacSHA1(s, secreKey);</p>
                            <p style="padding-left:30px;">return hmacSHA1Encrypt;</p>
                            <p>}</p>

                            <p>/**</p>
                            <p style="padding-left:6px;">* Hmac-SHA1 签名算法</p>
                            <p style="padding-left:6px;">*</p>
                            <p style="padding-left:6px;">* @param src 加密字符源串</p>
                            <p style="padding-left:6px;">* @param key  加密密钥</p>
                            <p style="padding-left:6px;">* @return 签名值</p>
                            <p style="padding-left:6px;">*/</p>
                            <p>public static String hmacSHA1(String src, String key) {</p>
                                <p style="padding-left:30px;">final String MAC_NAME = "HmacSHA1";</p>
                                <p style="padding-left:30px;">final String ENCODING = "UTF-8";</p>
                                <p style="padding-left:30px;">try {</p>
                                    <p style="padding-left:50px;white-space: nowrap;">SecretKeySpec signingKey = new SecretKeySpec(key.getBytes</p>
                                    <p style="padding-left:50px;"> (ENCODING),MAC_NAME);</p>
                                    <p style="padding-left:50px;">Mac mac = Mac.getInstance(MAC_NAME);</p>
                                    <p style="padding-left:50px;">mac.init(signingKey);</p>
                                    <p style="padding-left:50px;">byte[] rawHmac = mac.doFinal(src.getBytes(ENCODING));</p>
                                    <p style="padding-left:50px;">return Hex.encodeHexString(rawHmac).toUpperCase();</p>
                                    <p style="padding-left:30px;">} catch (Exception e) {</p>
                                        <p style="padding-left:50px;">log.error("hmacSHA1 error:{}", e);</p>
                                        <p style="padding-left:30px;">}</p>
                                        <p></p>
                            <p style="padding-left:30px;">return src;</p>
                            <p></p>
                            <p>}</p>

                            <p>/**</p>
                            <p style="padding-left:6px;">* 获取随机数</p>
                            <p style="padding-left:6px;">* @param length 长度</p>
                            <p style="padding-left:6px;">* @return</p>
                            <p style="padding-left:6px;">*/</p>
                            <p >public static String getNonceNum(int length) {</p>
                                <p style="padding-left:30px;white-space: nowrap;">String str = <span style="font-size: 8px;">"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";</span></p>
                                <p style="padding-left:30px;">Random random = new Random();</p>
                                <p style="padding-left:30px;">StringBuffer sb = new StringBuffer();</p>
                                <p style="padding-left:30px;">for (int i = 0; i < length; i++) {</p>
                                    <p style="padding-left:50px;">int number = random.nextInt(62);</p>
                                    <p style="padding-left:50px;">sb.append(str.charAt(number));</p>
                                    <p style="padding-left:30px;">}</p>
                                    <p style="padding-left:30px;">return sb.toString();</p>
                                    <p style="padding-left:0px;">}</p>
                                    <p>/**</p>
                                    <p style="padding-left:6px;">* 使用demo</p>
                                    <p style="padding-left:6px;">*/</p>
                                    <p>String nonceNum = StringUtils.getNonceNum(10);</p>
                                    <p>String t = Long.toString(System.currentTimeMillis() / 1000L);</p>
                                    <p ><span style="line-height: 20px;">String sign = StringUtils.getSign(aiotOpenServerAk, nonceNum, t, aiotOpenServerSk);</span></p>
                        </div>
                    </el-main>
                    </el-form>

                </el-container>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    export default{
        name:'instrcution',
        data(){
            return {
                name:'使用说明',
                shiyongfangfa:'',
                rightContentHeight:0,
                goif:1,
                paramData:[
                    {
                        name:'ak',
                        params:'564c7f09nd5e3tx88kl981db',
                        memo:'accessKey'
                    },
                    {
                        name:'nonce',
                        params:'788dede10e737a81',
                        memo:'随机字符串(对uuid取16位md5)'
                    },
                    {
                        name:'sign',
                        params:'FFF96C59885C6F611008B203797D0390A0ED4C6A',
                        memo:'签名'
                    },
                    {
                        name:'timestamp',
                        params:'1493449657',
                        memo:'Unix时间戳'
                    }
                ]
            }
        },
        created(){
            // 窗口尺寸变化时，使内容调整至合适状态
            this.reload();
            this.$onWindowResize.add(this.reload);
        },
        methods:{
            ifgo(value){
                console.log(value)
                this.goif=value;
            },
            reload() {
                this.$nextTick(function () {

                    this.rightContentHeight =document.getElementById('aside').clientHeight+'px';
                    console.log(this.rightContentHeight)
                });
            },
            goBack(){
                this.$router.go(-1);//返回上一层
            },
        }
    }
</script>
<style lang="scss">

    .white{
        background-color:#fff;
        margin-bottom:22px;
        box-shadow: 5px 5px 5px #bbb;
    }
    .daima{
        width:100%;
        background-color:#EFF2F5;
        padding:10px 36px;
        font-size:14px;
        color:rgb(96, 98, 102);
    }
    .elcontent p{
        font-size:14px;
        color:#333;
    }

    .activeheader{
        background-color: #4A90E2;
        color: #fff;
        border-radius: 4px;
        height: 30px;
        line-height: 30px;
        margin-top: 8px;
        padding-left: 15px;
        padding-right: 15px;
    }


</style>
